const HTML_TAG = /<\/?[a-z][\s\S]*>/i;

/** True when the string already carries HTML from the editor (or a past paste). */
export const looksLikeHtml = (value) => HTML_TAG.test(String(value || ''));

/**
 * Quill stores an empty field as `<p><br></p>`. Persist that as an empty string
 * so list cards stay blank. Strip script/style tags as a last line of defence.
 */
export const cleanRichText = (value) => {
  if (value == null) {
    return '';
  }
  const html = String(value);
  const stripped = html
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '');
  const probe = document.createElement('div');
  probe.innerHTML = stripped;
  const text = (probe.textContent || probe.innerText || '').replace(/\u00a0/g, ' ').trim();
  return text === '' ? '' : stripped;
};

/**
 * Drop heading, list, bold, italic and underline at the current Quill selection.
 * Color / background are left as-is — they are not part of “Style normal”.
 */
export const applyNormalRichTextStyle = (quill) => {
  if (!quill || typeof quill.getSelection !== 'function') {
    return;
  }
  const range = quill.getSelection(true);
  if (!range) {
    return;
  }

  if (range.length > 0) {
    quill.removeFormat(range.index, range.length);
  } else if (typeof quill.getLine === 'function' && typeof quill.getIndex === 'function') {
    const line = quill.getLine(range.index)?.[0];
    if (line) {
      const lineIndex = quill.getIndex(line);
      const lineLength = Math.max((typeof line.length === 'function' ? line.length() : 1) - 1, 0);
      if (lineLength > 0 && typeof quill.removeFormat === 'function') {
        quill.removeFormat(lineIndex, lineLength);
      }
    }
  }

  const blockLength = Math.max(range.length, 1);
  if (typeof quill.formatLine === 'function') {
    quill.formatLine(range.index, blockLength, 'header', false);
    quill.formatLine(range.index, blockLength, 'list', false);
  }
  if (typeof quill.format === 'function') {
    quill.format('bold', false);
    quill.format('italic', false);
    quill.format('underline', false);
  }
};

/** Compact preview for tables and cards — no HTML tags. */
export const plainTextFromRichText = (value) => {
  if (value == null) {
    return '';
  }
  if (!looksLikeHtml(value)) {
    return String(value).replace(/\s+/g, ' ').trim();
  }
  const probe = document.createElement('div');
  probe.innerHTML = String(value);
  probe.querySelectorAll('p, h1, h2, h3, li, br, div').forEach((node) => {
    node.after(' ');
  });
  return (probe.textContent || probe.innerText || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
};
